import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import Layout from "../components/Layout/Layout";
import DashboardLayout from "../user/components/DashboardLayout";
import "./PaymentHistory.css";
import HeroSvg from "../components/Layout/HeroSvg";
import {
  ChevronLeftSvg,
  ListSvg,
} from "../components/AllSvgModulesExport/LoginSvg";
import { useNavigate } from "react-router-dom";
import { setActiveButton } from "../redux/features/footerMenuSlice";
import { apiClient } from "../config/api.client";

const PaymentHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const [payments, setPayments] = useState([]);
  const [sideMenu, setSideMenu] = useState(false);

  async function getUserPayments() {
    try {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - 30); // Get last 30 days

      const res = await apiClient.get("/transaction/history", {
        params: {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
          page: 1,
          limit: 50,
        },
      });
      if (res.data?.success) {
        const mapped = (res.data.transactions || []).map((t) => ({
          txnId: t?.txnId || t?.utr || t?.gatewayOrderId || t?.orderId,
          name: t?.customerName || "N/A",
          email: t?.customerEmail || "N/A", 
          amount: t?.amount,
          createdAt: t?.createdAt,
          status: t?.status || "completed",
          type: t?.status || "payment", // Add type field to prevent undefined error
        }));
        setPayments(mapped);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (user !== null) {
      getUserPayments();
    }
  }, [user]);

  const onClose = () => {
    dispatch(setActiveButton("home"));
    navigate("/");
    localStorage.setItem("activeButton", "home");
  };

  return (
    <Layout>
      <DashboardLayout>
        {/* DESKTOP  */}
        {/* DESKTOP  */}
        {/* DESKTOP  */}
        <div className="payment-containers d-none d-md-block d-lg-block">
          <table className="table">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Order ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {payments?.length === 0 ? (
                <tr>
                  <td colSpan={100}>
                    <p className="text-center m-0">No Record Found</p>
                  </td>
                </tr>
              ) : (
                payments?.map((item, index) => {
                  return (
                    <tr>
                      <td>
                        <small>{index + 1}</small>
                      </td>
                      <td>
                        <small>{item?.txnId}</small>
                      </td>
                      <td>
                        <small>{item?.name}</small>
                      </td>
                      <td>
                        <small>{item?.email}</small>
                      </td>
                      <td>
                        <small>{item?.amount}</small>
                      </td>
                      <td>
                        <small>{item?.status}</small>
                      </td>
                      <td>
                        <small>
                          {new Date(item?.createdAt).toLocaleString(
                            "default",
                            {}
                          )}
                        </small>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* MOBILE  */}
        {/* MOBILE  */}
        {/* MOBILE  */}
        <div className={`account-modal-container d-lg-none d-md-none `}>
          <HeroSvg />
          <div className="account-modal-container-content">
            <div className="top-left-content">
              <div className="box-1 center" onClick={onClose}>
                <ChevronLeftSvg />
              </div>
              <h2 className="mb-0">Home</h2>
            </div>
            <div
              className="top-right-content box-2 center"
              onClick={() => setSideMenu(!sideMenu)}
            >
              <ListSvg />
            </div>
          </div>
          <div className="payment-containers d-block d-md-block d-lg-none">
            <p>Payment History</p>
            <hr />
            {payments?.length === 0 ? (
              <p className="text-center m-0">No Record Found</p>
            ) : (
              payments?.map((item, index) => {
                return (
                  <div className="payments w-100">
                    <div className="item">
                      <h5>{item?.txnId}</h5>
                      <span>₹{item?.amount}</span>
                    </div>
                    <div className="item">
                      <span className="text-muted">
                        <small>
                          {new Date(item?.createdAt).toLocaleString("default", {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric",
                          })}
                        </small>
                      </span>
                      <span className="fw-bold text-primary">
                        <small>{(item?.type || "payment").toUpperCase()}</small>
                      </span>
                    </div>
                    {index !== payments.length - 1 && <hr />}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </DashboardLayout>
    </Layout>
  );
};

export default PaymentHistory;
